module.exports = __webpack_public_path__ + "img/res-4.4820b6aa.png";